import { useEffect, useState } from "react";

const readSessionValue = <T>(key: string, fallback: T): T => {
  try {
    const stored = sessionStorage.getItem(key);
    return stored === null ? fallback : (JSON.parse(stored) as T);
  } catch {
    return fallback;
  }
};

export const useSessionState = <T>(key: string, fallback: T) => {
  const [value, setValue] = useState<T>(() => readSessionValue(key, fallback));

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch {
      return;
    }
  }, [key, value]);

  return [value, setValue] as const;
};
